import { Fragment } from "react";
import { Card } from "react-bootstrap";

export default function EquipamentoLayout({ children }) {
    return (
        <Fragment>
            <Card className='card-user'>
                {children}
            </Card>
        </Fragment>
    )
}
